<form (ngSubmit)="onSubmit()" [formGroup]="settingsForm">
  <div id="dashboard-section-basic-info-info" class="content-box_module__333d9 content-box_lg__3v3a- mb-10">
    <header class="content-box_header__xPnGx clearfix">
      <div class="wil-float-left">
        <h4 class="content-box_title__1gBHS">
          <span>Store Settings</span>
        </h4>
      </div>
    </header>
    <div class="content-box_body__3tSRB">
      <div class="banner-wrapper">
        <div class="banner">
          <div>
            <app-image-input uploadDirectory="shop" text="SELECT A BANNER IMAGE" [control]="settingsForm.get('banner')">
            </app-image-input>
          </div>
        </div>
      </div>

      <div class="core-section">
        <div class="profile-image">
          <app-image-input uploadDirectory="shop" text="SELECT A PROFILE IMAGE *"
            [control]="settingsForm.get('profile_picture')"></app-image-input>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Store Name</mat-label>
            <input matInput formControlName="store_name" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Store Product Per Page</mat-label>
            <input matInput type="number" formControlName="product_per_page" />
          </mat-form-field>
          <mat-checkbox color="primary" formControlName="show_more_products">
            Enable tab on product single page view
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div id="dashboard-section-basic-info-info" class="content-box_module__333d9 content-box_lg__3v3a- mb-10">
    <header class="content-box_header__xPnGx clearfix">
      <div class="wil-float-left">
        <h4 class="content-box_title__1gBHS">
          <span>Contact</span>
        </h4>
      </div>
    </header>
    <div class="content-box_body__3tSRB">
      <mat-form-field>
        <mat-label>Street</mat-label>
        <input required matInput formControlName="street" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Street 2</mat-label>
        <input matInput formControlName="street_2" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>City</mat-label>
        <input required matInput formControlName="city" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Post / ZIP Code</mat-label>
        <input required matInput formControlName="zip" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>State</mat-label>
        <input required matInput formControlName="state" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Country</mat-label>
        <mat-select required formControlName="country">
          <mat-option *ngFor="let country of countries$ | async" [value]="country.title">
            {{ country.title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Phone Number</mat-label>
        <input required matInput formControlName="phone" placeholder="+123456..." />
      </mat-form-field>
      <mat-checkbox color="primary" formControlName="show_email"> Show email address in store </mat-checkbox>
    </div>
  </div>

  <!-- <div id="dashboard-section-basic-info-info" class="content-box_module__333d9 content-box_lg__3v3a- mb-10">
    <header class="content-box_header__xPnGx clearfix">
      <div class="wil-float-left">
        <h4 class="content-box_title__1gBHS">
          <span>Uptime</span>
        </h4>
      </div>
    </header>
    <div class="content-box_body__3tSRB" formGroupName="uptime">
      <mat-checkbox color="primary" formControlName="show_uptime">
        Show store opening closing time widget in store page
      </mat-checkbox>
      <ng-container *ngIf="settingsForm.get('uptime.show_uptime').value">
        <div *ngFor="let day of days" class="uptime-container" [formGroupName]="day.value">
          <mat-form-field>
            <mat-label>{{ day.label }}</mat-label>
            <mat-select formControlName="up">
              <mat-option [value]="false">Close</mat-option>
              <mat-option [value]="true">Open</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="getUptimeDayCtrl(day.value + '.up').value">
            <mat-label>Opens at</mat-label>
            <mat-select formControlName="opens">
              <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="getUptimeDayCtrl(day.value + '.up').value">
            <mat-label>Closes at</mat-label>
            <mat-select formControlName="closes">
              <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field>
          <mat-label>Store Open Notice</mat-label>
          <input matInput formControlName="open_notice" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Store Close Notice</mat-label>
          <input matInput formControlName="close_notice" />
        </mat-form-field>
      </ng-container>
    </div>
  </div> -->

  <p *ngIf="showError" class="errorMessage">{{ errorMessage }}</p>

  <button mat-raised-button class="wil-btn wil-btn--primary wil-btn--round wil-btn--lg wil-btn--block" color="primary"
    type="submit" [disabled]="!settingsForm.valid">
    Save Settings
  </button>
</form>